<template>
	<iframe
		src="https://wholesale.wookah.pl/api/public/api/promotion"
		type="application/pdf"
		class="w-100 h-100 border-1s"
	>
		Oops! an error has occurred.
	</iframe>
</template>
<script>

export default {
	name: 'OtherPromotion',
	components: {},
	computed: {},
	data: () => ({}),
	methods: {},
	created() {
	}
};
</script>
